import { useTranslation } from 'react-i18next';

import { pagePathSegments } from '~constants';
import { UserRoleEnum } from '~enums';

import SideMenuContainer from './sideMenuContainer';
import { SideMenuEntry, SideMenuItemType } from './types';

// TODO: Some positions in menu are commented as they are not yet done. Probably to extend/clean up in the future.

/**
 * The application's primary navigation. This file owns only the menu's
 * structure (the entries); all layout and behaviour lives in
 * {@link SideMenuContainer} and the `./items` renderers.
 */
const SideMenu = () => {
	const { t } = useTranslation();

	const entries: SideMenuEntry[] = [
		{
			type: SideMenuItemType.Page,
			label: t('dashboard', { ns: 'nav' }),
			path: pagePathSegments.Home,
			iconName: 'icon/bar-chart-square',
		},
		{
			type: SideMenuItemType.Section,
			title: t('management', { ns: 'nav' }),
			items: [
				{
					type: SideMenuItemType.Page,
					label: t('organisation.labels.plural', { ns: 'entities' }),
					path: pagePathSegments.Organisations,
					iconName: 'icon/office',
					roles: [UserRoleEnum.SuperAdmin, UserRoleEnum.Support],
				},
				{
					type: SideMenuItemType.Page,
					label: t('device.labels.plural', { ns: 'entities' }),
					path: pagePathSegments.Devices,
					iconName: 'icon/device',
				},
				{
					type: SideMenuItemType.Page,
					label: t('key.labels.plural', { ns: 'entities' }),
					path: pagePathSegments.Keys,
					iconName: 'icon/key',
				},
				{
					type: SideMenuItemType.Page,
					label: t('user.labels.plural', { ns: 'entities' }),
					path: pagePathSegments.Users,
					iconName: 'icon/users',
					roles: [UserRoleEnum.SuperAdmin, UserRoleEnum.ClientAdmin, UserRoleEnum.Support],
				},
			],
		},
		// {
		// 	type: SideMenuItemType.Section,
		// 	title: t('operations', { ns: 'nav', defaultValue: 'Operations' }),
		// 	items: [
		// 		{
		// 			type: SideMenuItemType.Dropdown,
		// 			title: t('manufacturing', { ns: 'nav', defaultValue: 'Manufacturing' }),
		// 			iconName: 'icon/tools',
		// 			roles: [UserRoleEnum.SuperAdmin, UserRoleEnum.Manufacturing],
		// 			pages: [
		// 				{
		// 					type: SideMenuItemType.Page,
		// 					label: t('workTasks', { ns: 'nav', defaultValue: 'Work tasks' }),
		// 					path: 'work-tasks',
		// 					iconName: 'icon/file',
		// 					badge: 3,
		// 				},
		// 				{
		// 					type: SideMenuItemType.Page,
		// 					label: t('products', { ns: 'nav', defaultValue: 'Products' }),
		// 					path: 'products',
		// 					iconName: 'icon/box',
		// 				},
		// 				{
		// 					type: SideMenuItemType.Page,
		// 					label: t('shipments', { ns: 'nav', defaultValue: 'Shipments' }),
		// 					path: 'shipments',
		// 					iconName: 'icon/truck',
		// 					badge: 14,
		// 				},
		// 			],
		// 		},
		// 		{
		// 			type: SideMenuItemType.Page,
		// 			label: t('serviceTickets', { ns: 'nav', defaultValue: 'Service tickets' }),
		// 			path: 'service-tickets',
		// 			iconName: 'icon/ticket',
		// 			badge: 120,
		// 		},
		// 	],
		// },
		// {
		// 	type: SideMenuItemType.Section,
		// 	title: t('installers', { ns: 'nav', defaultValue: 'Installers' }),
		// 	items: [
		// 		{
		// 			type: SideMenuItemType.Page,
		// 			label: t('installations', { ns: 'nav', defaultValue: 'Installations' }),
		// 			path: 'installations',
		// 			iconName: 'icon/wrench',
		// 		},
		// 		{
		// 			type: SideMenuItemType.Page,
		// 			label: t('inspections', { ns: 'nav', defaultValue: 'Inspections' }),
		// 			path: 'inspections',
		// 			iconName: 'icon/eye',
		// 		},
		// 	],
		// },
		// {
		// 	type: SideMenuItemType.Section,
		// 	title: t('insights', { ns: 'nav', defaultValue: 'Insights' }),
		// 	items: [
		// 		{
		// 			type: SideMenuItemType.Page,
		// 			label: t('monitoring', { ns: 'nav', defaultValue: 'Monitoring' }),
		// 			path: 'monitoring',
		// 			iconName: 'icon/server',
		// 		},
		// 	],
		// },
	];

	const bottomEntries: SideMenuEntry[] = [
		{
			type: SideMenuItemType.Page,
			label: t('wiki', { ns: 'nav' }),
			path: pagePathSegments.Wiki,
			iconName: 'icon/book-open',
			roles: [UserRoleEnum.SuperAdmin, UserRoleEnum.ClientAdmin, UserRoleEnum.Support],
		},
		// {
		// 	type: SideMenuItemType.Page,
		// 	label: t('releaseNotes', { ns: 'nav' }),
		// 	path: pagePathSegments.ReleaseNotes,
		// 	iconName: 'icon/clock',
		// },
		// {
		// 	type: SideMenuItemType.Page,
		// 	label: t('settings', { ns: 'nav' }),
		// 	path: pagePathSegments.Profile,
		// 	iconName: 'icon/settings',
		// },
	];

	return <SideMenuContainer entries={entries} bottomEntries={bottomEntries} />;
};

export default SideMenu;
